import 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js'
const Intersector = new IntersectionObserver(
  entries =>
    entries.forEach(entry => {
      if (!entry.isIntersecting) return
      entry.target.init()
      Intersector.unobserve(entry.target)
    }),
  {
    rootMargin: '0px 0px 50px 0px',
  }
)
export class PivotCarousel extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    if (this.isConnected) Intersector.observe(this)
  }
  async init() {
    this.slides = [...this.querySelectorAll('.splide__slide')]

    this.attrs = this.__getAttributes()

    // Elementos
    this.slider = this.querySelector('.splide')
    this.list = this.querySelector('.splide__list')

    // Remover el contenedor inicial de slides
    this.querySelector('.pivot--carousel')?.remove()

    const desktopColumns = Number(this.attrs['desktop-columns'] || 1)
    const desktopRows = Number(this.attrs['desktop-rows'] || 1)
    const mobileColumns = Number(this.attrs['mobile-columns'] || 1)
    const mobileRows = Number(this.attrs['mobile-rows'] || 1)
    const enableGrid = this.attrs['enable-grid'] !== undefined

    this.desktopColumns = desktopColumns
    this.mobileColumns = mobileColumns

    const applyPadding =
      this.attrs['overflow'] !== undefined &&
      this.slides.length > desktopColumns
        ? { right: `${(100 / desktopColumns) * 0.5}%` }
        : undefined
    let applyMobilePadding =
      this.attrs['overflow'] !== undefined && this.slides.length > mobileColumns
        ? { right: `${(100 / mobileColumns) * 0.5}%` }
        : undefined
    applyMobilePadding =
      this.attrs['overflow'] !== undefined && mobileColumns == 1
        ? { right: '25%' }
        : applyMobilePadding

    const splideConfig = {
      perPage: desktopRows > 1 ? 1 : desktopColumns,
      perMove: this.attrs['desktop-per-page'] || desktopColumns,
      pagination: this.attrs['desktop-pagination'] !== undefined,
      arrows: this.attrs['desktop-arrows'] !== undefined,
      autoplay: this.attrs['desktop-autoplay'] !== undefined,
      interval: Number(this.attrs['desktop-duration'] || 5000),
      speed: 1000,
      gap:
        this.slides.length > 1
          ? 'calc(var(--grid-desktop-horizontal-spacing) * 2)'
          : '0px',
      trimSpace: true,
      type:
        this.attrs['transition'] !== 'fade' &&
        this.attrs['desktop-loop'] !== undefined
          ? 'loop'
          : this.attrs['transition'],
      rewind:
        this.attrs['transition'] === 'fade' &&
        this.attrs['desktop-loop'] !== undefined,
      drag: this.attrs['drag'] !== undefined,
      padding: applyPadding,
      breakpoints: {
        750: {
          perPage: mobileRows > 1 ? 1 : mobileColumns,
          perMove: this.attrs['mobile-per-page'] || desktopColumns,
          pagination: this.attrs['mobile-pagination'] !== undefined,
          arrows: this.attrs['mobile-arrows'] !== undefined,
          autoplay: this.attrs['mobile-autoplay'] !== undefined,
          interval: Number(this.attrs['mobile-duration'] || 5000),
          padding: applyMobilePadding,
          type:
            this.attrs['transition'] !== 'fade' &&
            this.attrs['mobile-loop'] !== undefined
              ? 'loop'
              : this.attrs['transition'],
          rewind:
            this.attrs['transition'] === 'fade' &&
            this.attrs['mobile-loop'] !== undefined,
        },
      },
    }

    if (enableGrid && desktopRows > 1) {
      splideConfig.grid = {
        dimensions: [[desktopRows, desktopColumns]],
        gap: {
          row: 'calc(var(--grid-desktop-vertical-spacing) * 4)',
          col: 'calc(var(--grid-desktop-horizontal-spacing) * 2)',
        },
      }
    }
    if (enableGrid && mobileRows > 1) {
      splideConfig.breakpoints[750].grid = {
        dimensions: [[mobileRows, mobileColumns]],
        gap: {
          row: 'calc(var(--grid-mobile-vertical-spacing) * 4)',
          col: 'calc(var(--grid-mobile-horizontal-spacing) * 2)',
        },
      }
    } else {
      splideConfig.breakpoints[750].grid = null
    }

    this.splide = new Splide(this.slider, splideConfig)
    const extensions = {}
    if (enableGrid) {
      await import(
        'https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-grid@0.4.1/dist/js/splide-extension-grid.min.js'
      )
      extensions.Grid = window.splide?.Extensions?.Grid
    }

    if (this.getAttribute('drag') !== null) {
      this.splide.on('overflow', isOverflow => {
        this.splide.options = {
          drag: isOverflow,
        }
      })
    }

    console.log(extensions)
    this.splide.mount(extensions)
    this.inited = true
    this.dispatchEvent(new CustomEvent('init', { bubbles: true }))
  }
  __getAttributes() {
    return this.getAttributeNames().reduce(
      (obj, name) => ({
        ...obj,
        [name]: this.getAttribute(name),
      }),
      {}
    )
  }
}
if (!customElements.get('pivot-carousel')) {
  customElements.define('pivot-carousel', PivotCarousel)
}

class PivotCarouselControls extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    if (!this.isConnected) return
    // Custom Arrows
    const nextArrow = this.querySelector(`.pivot-carousel__arrow--next`)
    const prevArrow = this.querySelector(`.pivot-carousel__arrow--prev`)
    const parent = this.closest('pivot-carousel, [pivot-carousel]')

    if (nextArrow)
      nextArrow.addEventListener('click', e => {
        parent?.splide?.Components.Controller.go('>')
      })
    if (nextArrow)
      prevArrow.addEventListener('click', e => {
        parent?.splide?.Components.Controller.go('<')
      })
  }
}
if (!customElements.get('pivot-carousel-controls')) {
  customElements.define('pivot-carousel-controls', PivotCarouselControls)
}

